module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Light-66396420636d52f257d5d90a14dffa33.ttf";